<template>
  <div class="privacy-policy-container" v-html="privacyPolicyContent"></div>
</template>

<script>
export default {
  name: 'PrivacyPolicyPage',
  data() {
    return {
      privacyPolicyContent: ''
    }
  },
  async mounted() {
    try {
      const response = await fetch('/privacy-policy.html')
      this.privacyPolicyContent = await response.text()
    } catch (error) {
      console.error('Error loading privacy policy:', error)
    }
  }
}
</script>

<style scoped>
.privacy-policy-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem;
}
</style>
